export const isSelectEnabled = ({ selectProps }: { selectProps: any }) =>
  !!Object.values(selectProps).length &&
  Object.values(selectProps).every((value) => !!value);
